/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, NavLink } from "react-bootstrap";

import { Table, TableBody, TableCell, TableContainer, TableRow, Chip, Button } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { getEquipmentCtgrImageNameByCodeOfDashboardSubMp4, getEquipmentCtgrImageNameByCodeOfDashboardSubNantongMp4, getSettledValue, groupAndDeduplicate, makeFaultsMessage3, ROLE } from 'data/data';
import { getEquipmentAlertsDiagnosisByQuery, getEquipmentsCategoriesById } from 'components/axios/equipmentAlertsAxios';
import { getEquipmentAliveStatusById, getEquipmentOpLogsTimeline, getEquipmentPartsWithSensorPositionByQuery, getEquipmentsById, getLiftOpLogsQuery } from 'components/axios/equipmentAxios';
import MainCard from 'components/MainCard';
import EquipmentPartListMonitoring from 'components/inner/EquipmentPartListMonitoring';
import InspectionModal from 'components/modal/InspectionModal';
import ComprehensiveReportLayer from 'components/layer/ComprehensiveReportLayer';
import EquipmentRemarkModifyLayer from 'components/layer/EquipmentRemarkModifyLayer';
import EquipmentStatusLayer from 'components/layer/EquipmentStatusLayer';
import EquipmentChecklistLayer from 'components/layer/EquipmentChecklistLayer';
import { getEquipmentPartsIncludingFaultsByEquipmentId } from 'components/axios/masterEquipmentPartsImageAxios';
import { getEquipmentMeasurementLogsLatestQuery } from "components/axios/equipmentAxios";
import useConfig from 'hooks/useConfig';
import EquipmentRightTopTabList from 'components/inner/EquipmentRightTopTabList';
import StatusTab from 'components/inner/equipment/StatusTab';
import EquipmentPanel from 'components/inner/EquipmentPanel';
import StatusStatusTab from 'components/inner/equipment/StatusStatusTab';
import PictureTab from 'components/inner/equipment/PictureTab';
import { useQuery } from '@tanstack/react-query';
import MaintenanceTaskAndAlertModal from 'components/modal/MaintenanceTaskAndAlertModal';
import Error404 from 'pages/Error404';
import ElevatorInfoButton from 'components/button/ElevatorInfoButton';
// import EquipmentElevatorInfo from 'components/inner/EquipmentElevatorInfo';
// import CCTVWebRTCLayer from 'components/layer/CCTVWebRTCLayer';
// import CCTVButtons from 'components/CCTVButtons';
// import CircleChart from 'components/inner/chart/CircleChart';

// const DELAY_TIME =  30000;
const DELAY_TIME = Number(process.env.REACT_APP_DELAY_TIME) || 60000;

const createEmptyParts = (count = 6) =>
  Array.from({ length: count }, () => ({
    partName: "",
    partCode: "",
    partPosition: "",
    normalFileId: 0,
    errorFileId: 0,
    fileId: 0,
    hasFaultCodesOfAlertY: false,
    hasFaultCodesOfAlertN: false,
  })
);

const normalizeEquipmentParts = (data) => {
  if (!data || data.length === 0) {
    return createEmptyParts();
  }

  const list = data.map(p => {
    const isNormal =
      !p.hasFaultCodesOfAlertY &&
      !p.hasFaultCodesOfAlertN;
    
    let fileId = 0;
    let fileContentType = null;

    if (isNormal) {
      if (p.normalFileId == null && p.errorFileId != null) {
        fileId = p.errorFileId;
        fileContentType = p.errorFileContentType;
      } else if (p.errorFileId == null) {
        fileId = 0;
        fileContentType = null;
      } else {
        fileId = p.normalFileId;
        fileContentType = p.normalFileContentType;
      }
    } else {
      if (p.errorFileId == null && p.normalFileId != null) {
        fileId = p.normalFileId;
        fileContentType = p.normalFileContentType;
      } else if (p.normalFileId == null) {
        fileId = 0;
        fileContentType = null;
      } else {
        fileId = p.errorFileId;
        fileContentType = p.errorFileContentType;
      }
    }

    return {
      ...p,
      fileId,
      fileContentType,
      __isNormal: isNormal
    };

  });

  /* ===================== 정렬 추가 ===================== */
  list.sort((a, b) => {
    // 비정상(false)이 먼저 오도록
    return Number(a.__isNormal) - Number(b.__isNormal);
  });

  const cleaned = list.map(({ __isNormal, ...rest }) => rest);

  return cleaned.length < 6
    ? [...cleaned, ...createEmptyParts(6 - cleaned.length)]
    : cleaned;
};

const EquipmentViewMonitoring = () => {
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const isViewCommError = process.env.REACT_APP_SHOW_NETWORK_ERROR_TO_ALL_YN === 'Y';
    const { getEnumValueByEnumNameAndCode, loginInfo, role } = useEnumApi();
    const { t } = useTranslation();
    const { mode } = useConfig();
    const {id} = useParams();

    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
    }, [id]);

    const { 
      data : info, 
      refetch : equipRefetch, 
      isLoading: equipIsLoading, 
      isSuccess,
      isError: equipIsError,
      error: equipError
     } = useQuery({
      queryKey: ['equipment-iot-view-base', id],

      queryFn: () => getEquipmentsById(id),

      // 깜빡임 방지
      placeholderData: previousData => previousData,

      // 🔥 기존 polling 대체
      // refetchInterval: DELAY_TIME,
      refetchInterval: notFound
        ? false
        : DELAY_TIME,

      refetchOnWindowFocus: false,
      refetchOnReconnect: false,

      // 🔥 탭 안 보여도 멈추지 않음(기본값은 false)
      refetchIntervalInBackground: true,

      enabled: !!id,
      retry: false,
      onError: (error) => {
        if (error?.response?.status === 404) {
            setNotFound(true);
        }
      }
    });
// console.log(info)
    const { data, refetch: otherRefetch , isLoading } = useQuery({
      queryKey: ['equipment-iot-view', id],

      queryFn: async () => {

        const [
          categoriesResult,
          // equipResult,
          alertDResult,
          alertMResult,

          partsWithSensorResult,
          measurementLogsResult,
          partsIncludingFaultsResult,
          alertsResult,
          aliveStatusInfoResult
        ] = await Promise.allSettled([
          getEquipmentsCategoriesById(id),
          // getEquipmentsById(id),
          getEquipmentAlertsDiagnosisByQuery({
            "equipment.id": id,
            status: "D",
            fllwActionType: "O1_WAIT",
            sort: "latestAlertedAt,desc",
            // page: 1,
            size: 1
          }),
          getEquipmentAlertsDiagnosisByQuery({
            "equipment.id": id,
            status: "M",
            fllwActionType: "O2_OBSERVE",
            sort: "latestAlertedAt,desc",
            "atentObserv.status": "V",
            size: 1
          }),
          
          getEquipmentPartsWithSensorPositionByQuery({
            "equipment.id": id,
            deletedYn: false
          }),
          getEquipmentMeasurementLogsLatestQuery({
            "equipment.id": id
          }),
          getEquipmentPartsIncludingFaultsByEquipmentId(id),
          getEquipmentAlertsDiagnosisByQuery({
            sort: "latestAlertedAt,desc",
            page: 0,
            size: 20,
            "equipment.id": id
          }),
          getEquipmentAliveStatusById(id)
        ]);

         return {
          categories: getSettledValue(categoriesResult),
          // equip: getSettledValue(equipResult),
          alertD: getSettledValue(alertDResult),
          alertM: getSettledValue(alertMResult),
          partsWithSensor: getSettledValue(partsWithSensorResult, []),
          alerts: getSettledValue(alertsResult),
          measurementLogs: getSettledValue(measurementLogsResult),
          partsIncludingFaults: getSettledValue(partsIncludingFaultsResult, []),
          aliveStatusInfo: getSettledValue(aliveStatusInfoResult)
        };
      },

      // 깜빡임 방지
      placeholderData: previousData => previousData,

      // 🔥 기존 polling 대체
      refetchInterval: DELAY_TIME,

      refetchOnWindowFocus: false,
      refetchOnReconnect: false,

      // 🔥 탭 안 보여도 멈추지 않음(기본값은 false)
      refetchIntervalInBackground: true,

      enabled: !!id && isSuccess && !!info
    });

    const refetch = useCallback(() => {
      equipRefetch();
      otherRefetch();
    }, []);

    // 1번 탭 데이터 존재 여부 체크
    const { data: controlCheckData, isFetched: isControlChecked } = useQuery({
        queryKey: ['liftOpControlLogs', 'check', id, { page: 0, size: 1 }],
        queryFn: () => getLiftOpLogsQuery({ page: 0, size: 1, "equipmentId": id }),
        // queryFn: () => getLiftOpLogsQuery({ page: 0, size: 1, "equipment.id": equipment?.id, "controlPanelCode.usrDfnCd": "isNotNull()" }),
        enabled: !!id && isSuccess && !!info,
        staleTime: 1000 * 30, // 30초 동안은 캐시 유지 (존재 여부 체크를 매번 DB 조회하지 않음)
        gcTime: 1000 * 60 * 5,
    });

    // 2번 탭 데이터 존재 여부 체크
    const { data: timelineCheckData, isFetched: isTimelineChecked } = useQuery({
        queryKey: ['liftOperationLogs', 'check', id, { page: 0, size: 1 }],
        queryFn: () => getEquipmentOpLogsTimeline(id, { page: 0, size: 1 }),
        enabled: !!id && isSuccess && !!info,
        staleTime: 1000 * 30, // 30초 동안은 캐시 유지 (존재 여부 체크를 매번 DB 조회하지 않음)
        gcTime: 1000 * 60 * 5,
    });

    const hasControlData  = (controlCheckData?.totalElements ?? 0) > 0;
    const hasTimelineData = (timelineCheckData?.page?.totalElements ?? 0) > 0;

    const equipmentComponents = data?.categories;
    // const info = equipData;
    const equipmentAlerts = data?.alerts?._embedded?.equipmentAlerts ?? [];
    const measurementLogsLatest = data?.measurementLogs;
    const equipmentAliveStatus = data?.aliveStatusInfo;
    const equipmentComponentList = data?.partsIncludingFaults;
    
    const equipmentAlertIng =
      data?.alertD?._embedded?.equipmentAlerts?.[0]
      ?? data?.alertM?._embedded?.equipmentAlerts?.[0]
      ?? null;

    const equipmentPartsExistSeneorPosition = useMemo(() => {
      return data?.partsWithSensor?.filter(
        ep =>
          ep.sensorPositions?.length > 0 &&
          ep.lowestDiagnosisRank != null 
      ) ?? [];
    }, [data?.partsWithSensor]);

    const equipmentPartsWithSensorPosition = useMemo(() => {
      return groupAndDeduplicate(
        data?.partsWithSensor ?? [],
        {
          groupBy: [
            "masterEquipmentPart.equipmentCtgr.id",
            "componentLocation.id",
            "componentLocation.code",
            "componentLocation.name"
          ],
          dedupeBy: []
        }
      );
    }, [data?.partsWithSensor]);
        
    const [componentId, setComponentId] = useState(-2);
    const [locationCode, setLocationCode] = useState(0);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [activeVideoPartId, setActiveVideoPartId] = useState(null);

    // 해당 구성부에 해당하는 자재목록
    const equipmentPartsByComponentId = (compId) => {
      setComponentId(compId);
      setLocationCode(null);

      if (compId > 0) {
        setSelectedComponent(
          equipmentComponentList.find(
            component => component.componentId === compId
          )
        )
      }
    }

    // 부품이미지
    const equipmentParts = useMemo(() => {
      return normalizeEquipmentParts(
        equipmentComponentList
      );
    }, [equipmentComponentList]);

    const companyName = useMemo(() => {
      if (!info) return '';

      if (
        loginInfo?.company?.type === "MAN" &&
        info.maintenanceCompany?.info?.name
      ) {
        return info.maintenanceCompany.info.name;
      }

      return info.managementCompany?.info?.name ?? '';
    }, [info, loginInfo?.company?.type]);

    const imgName = useMemo(() => {
      if (!info) return 'sample.png';

      const op = info.latestEquipmentOp;

      if (platformServer === 'NANTONG') {
        return getEquipmentCtgrImageNameByCodeOfDashboardSubNantongMp4(
            info?.equipmentCtgr?.parent?.parent?.code,
            op?.opStatus ?? null,
            op?.opStatusDetail ?? null,
            op?.doorStatus ?? null,
            "view"
          )
      } else {
        return getEquipmentCtgrImageNameByCodeOfDashboardSubMp4(
            info?.equipmentCtgr?.code,
            op?.opStatus ?? null,
            op?.opStatusDetail ?? null,
            op?.doorStatus ?? null,
            "view"
          )
      }
    }, [ 
      info?.equipmentCtgr?.parent?.parent?.code,
      info?.equipmentCtgr?.code,
      info?.latestEquipmentOp?.opStatus,
      info?.latestEquipmentOp?.opStatusDetail,
      info?.latestEquipmentOp?.doorStatus
    ]);

    const [previewImage, setPreviewImage] = useState('');
    const [extension, setExtension] = useState("png");
    const [selectedImg, setSelectedImg] = useState([]);
    const [selectedImgId, setSelectedImgId] = useState(null);
    const [selectedBp, setSelectedBp] = useState("");
    // const [stream, setStream] = useState(null);
    const [selectedStream, setSelectedStream] = useState(null);
    
    const initDefaultImage = useCallback(() => {
      setSelectedStream(null);
      setSelectedImg([]);
      setSelectedBp("");
    }, []);

    const setImageFromFile = useCallback((file, selectIdx) => {
      initDefaultImage();
      setPreviewImage(window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+file?.id);
      setExtension("png");
      // console.log(selectIdx)
      if (selectIdx <= (info?.imgFiles?.length ?? 0)) {
        // console.log(selectIdx, file.id)
        let copy = Array(info?.imgFiles?.length ?? 0).fill("");
        copy[selectIdx-1] = " on";
        setSelectedImg(copy);
        setSelectedBp("");
        setSelectedImgId(file.id)
      } else {
        // console.log(selectIdx, file.id)
        setSelectedImg([]);
        setSelectedImgId(file.id)
        setSelectedBp(" on");
      }
    }, [info, initDefaultImage]);

    const setDefaultImageFromFile = useCallback((selectIdx) => {
      initDefaultImage();
      setPreviewImage(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
      setExtension("png");
      if (selectIdx <= (info?.imgFiles?.length ?? 0)) {
        let copy = Array(info?.imgFiles?.length ?? 0).fill("");
        copy[selectIdx-1] = " on";
        setSelectedImg(copy);
        setSelectedBp("");
      } else {
        setSelectedImg([]);
        setSelectedBp(" on");
      }
    }, [info, mode, initDefaultImage]);

    const playMovie = useCallback((partCode, locationCode, diagnosisId) => {
      const uniqueKey = `${locationCode}_${partCode}_${diagnosisId}`;
      setActiveVideoPartId(prev => prev === uniqueKey ? null : uniqueKey);
    }, []);

    useEffect(()=>{
      if (info) {
        let copy = Array(info.imgFiles?.length).fill("");
        // if (info && info.imgFiles && info.imgFiles.length > 0) {
        if (info?.imgFiles?.length > 0) {
          // 선택된 항목이 사라졌을 때만 초기화
          if (!info.imgFiles.some(v => v.id === selectedImgId) && info.bpFile?.id !== selectedImgId) {
            // console.log(22222222)
            // console.log(selectedImgId)
            setImageFromFile(info.imgFiles[0], 1);
            copy[0] = " on";
          }
        } else {
          setPreviewImage(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        }
        setSelectedImg(copy);
        setSelectedBp("");
      }
    }, [info?.imgFiles, info?.bpFile, selectedImgId, mode, setImageFromFile]);
      // },[info, mode]);

    // const setCCTV = ( stream ) => {
    //   // console.log(stream)
    //   setStream(stream);
    //   // setPreviewImage(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
    //   setSelectedImg([]);
    //   setSelectedBp("");
    // };

    if (notFound) {
        return <Error404 />;
    }
    if (info) {
        return (
    <div className="sub_container">
        <div className="moni_tit_box" style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
          <h5 style={{color:"#d3e0ec", borderRadius:"0"}}>
          {info.name}{companyName ? ' - '+companyName:''}
          </h5>
          <div>
          <><InspectionModal id={info.id} onRefresh={refetch} /></>
          {/* &nbsp;<CCTVWebRTCLayer stream="stream1" /> */}
          &nbsp;<EquipmentChecklistLayer info={info} />
          &nbsp;<ComprehensiveReportLayer info={info} previewImage={previewImage} />
          &nbsp;<ElevatorInfoButton info={info} />
          </div>
        </div>
        
        <Row>
          <Col sm={7} className="sub_left sub_left1">
            <StatusTab info={info} measurementLogsLatest={measurementLogsLatest} equipmentPartsExistSeneorPosition={equipmentPartsExistSeneorPosition}  
              imgName={imgName} equipmentParts={equipmentParts} 
              equipmentPartsByComponentId={equipmentPartsByComponentId} setLocationCode={setLocationCode} activeVideoPartId={activeVideoPartId} />
            
            <div className="btn_right" style={{marginTop:"10px", justifyContent:'space-between'}}>
              <Link to={'..' + window.location.search}>
                <Button
                  className="pop_style_btn"
                  type="button"
                  style={{
                    height: "35px",
                    minHeight: "35px"
                  }}
                >
                  <span>{t('message.common.btn.list')}</span>

                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                    style={{
                      display: "block",
                      flexShrink: 0
                    }}
                  >
                    <path d="M8 6h13M8 12h13M8 18h13" />
                    <path d="M3 6h.01M3 12h.01M3 18h.01" />
                  </svg>
                </Button>
              </Link>

                &nbsp;&nbsp;<MaintenanceTaskAndAlertModal equipmentId={info.id} onRefresh={refetch} />
            </div>
          </Col>

          <Col sm={5} className="sub_right">
            <div className='alert_phrase' style={{marginBottom: "10px", padding: "0"}}>
              <MainCard className="center_table table_set1" content={false}>
                <TableContainer>
                  <Table sx={{ minWidth: 500 }} aria-label="simple table">
                    <TableBody>
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                        <TableCell align="center">{info?.equipmentCtgr?.parent?.name}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                        <TableCell align="center" colSpan={2}>{info?.equipmentCtgr?.name}</TableCell>
                        <TableCell align="center"><EquipmentStatusLayer info={info} /></TableCell>
                      </TableRow>
                      }
                      <TableRow>
                          <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title} ({t('message.common.subtitle.company.contact')})</TableCell>
                          <TableCell align="center">{info && info.managementCompany?.info?.name}{info.managementCompany?.info?.contact && `(${info.managementCompany?.info?.contact})`}</TableCell>
                          <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title} ({t('message.common.subtitle.company.contact')})</TableCell>
                          <TableCell align="center" colSpan={3}>{info && info.maintenanceCompany?.info?.name}{info.maintenanceCompany?.info?.contact && `(${info.maintenanceCompany?.info?.contact})`}</TableCell>
                      </TableRow>
                      <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                          <TableCell align="center">{info.equipmentNo}</TableCell>
                          <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title} ({t('message.common.subtitle.company.contact')})</TableCell>
                          <TableCell align="center" colSpan={3}>{info && info.manufacturingCompany?.info?.name}{info.manufacturingCompany?.info?.contact && `(${info.manufacturingCompany?.info?.contact})`}</TableCell>
                      </TableRow>
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                        <TableCell align="center">{info.instlYmd}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                        <TableCell align="center" colSpan={3}>{info.location}</TableCell>
                      </TableRow>
                      }
                      {info &&
                      <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                        <TableCell align="center" colSpan={5}>
                          <div  style={{display:"flex"}}>
                            <div style={{whiteSpace:"pre-line", textAlign:"left", width:"100%"}}>
                              {info.remark}
                            </div>
                            <EquipmentRemarkModifyLayer equipmentId={info.id} onRefresh={refetch} />
                          </div>
                        </TableCell>
                      </TableRow>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </MainCard>
            </div>

            {/* 통신이상 */}
            {(isViewCommError || role === ROLE.SA.code) && equipmentAliveStatus && (equipmentAliveStatus?.gatewayCount?.dead > 0 || equipmentAliveStatus?.sensorCount?.dead > 0) &&
            <div className='alert_phrase' style={{marginBottom: "10px"}}>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <Chip label={t('message.common.subtitle.iot.status')} color="primary" />
                </div>
              </div>
            
              <div className='alert_phrase_cont' style={{display:'flex', alignItems:'center', justifyContent: "flex-start"}}>
                <img src={`${process.env.PUBLIC_URL}/img/icon/wifi_off.png`} />
                <p>
                {equipmentAliveStatus?.gatewayCount?.dead > 0 &&
                  <React.Fragment>
                    GW {t('message.common.subtitle.communication.issue')} :
                    {equipmentAliveStatus?.gateways.filter(gateway=>gateway.aliveStatus === 'D').map(gateway=>gateway.gatewaySn).join(', ')}
                    <br/>
                  </React.Fragment>
                }
                {equipmentAliveStatus?.sensorCount?.dead > 0 &&
                  <React.Fragment>
                    {t('message.common.select.sensor')} {t('message.common.subtitle.communication.issue')} :
                    {equipmentAliveStatus?.sensors.filter(sensor=>sensor.aliveStatus === 'D').map(sensor=>sensor.sensorSn).join(', ')}
                  </React.Fragment>
                }
                </p>
              </div>
            </div>
            }

            {/* 경보 및 관심 */}
            {equipmentAlertIng && 
            <div className='alert_phrase' style={{marginBottom: "10px"}}>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <Chip className={equipmentAlertIng?.fllwActionType} label={equipmentAlertIng?.fllwActionType === 'O1_WAIT' ? t('message.common.title.alarm') : t('message.common.title.reference')} color="primary" />
                </div>
              </div>
            
              <div className='alert_phrase_cont' style={{display:'flex', alignItems:'center', justifyContent: "flex-start"}}>
                <NavLink href={`/equipment-alert-history-tracking/${equipmentAlertIng.id}`}><img src={`${process.env.PUBLIC_URL}/img/icon/${equipmentAlertIng?.fllwActionType === 'O1_WAIT' ? 'notification_o':'notification_y'}.png`} /></NavLink>
                <p>
                {equipmentAlertIng?.alertDtl ?? ''}{equipmentAlertIng?.alertDtl && <br/>}
                {equipmentAlertIng && makeFaultsMessage3(equipmentAlertIng, getEnumValueByEnumNameAndCode, playMovie)}
                </p>
              </div>
            </div>
            }

            {/* 탭목록 */}
            <EquipmentRightTopTabList equipment={info} measurementLogsLatest={measurementLogsLatest} equipmentAlerts={equipmentAlerts} 
              equipmentComponents={equipmentComponents} componentId={componentId} equipmentPartsByComponentId={equipmentPartsByComponentId}
              hasControlData={hasControlData} hasTimelineData={hasTimelineData} isPannelLoaded={isControlChecked && isTimelineChecked}
              type='type2' />
                        
            {/* 상태현황 */}
            {componentId && componentId === -2 && info &&
            <StatusStatusTab info={info} measurementLogsLatest={measurementLogsLatest} />
            }
            {/* 운전/진단 */}
            {((info?.latestEquipmentOp || equipmentAlerts?.length>0 || hasControlData || hasTimelineData) && componentId && componentId === -1) && info && 
            <EquipmentPanel equipment={info} />
            }
            {/* 사진/도면 */}
            {componentId && componentId === -3 && info &&
            <PictureTab info={info} previewImage={previewImage} extension={extension} selectedStream={selectedStream} 
              selectedImgId={selectedImgId} onRefresh={refetch} setDefaultImageFromFile={setDefaultImageFromFile} setImageFromFile={setImageFromFile} />
            }
            {/* 구성부탭목록 */}
            {componentId && componentId > 0 && info &&
            <div className='alert_phrase'>
              <EquipmentPartListMonitoring equipment={info} componentId={componentId} equipmentAlertIng={equipmentAlertIng} equipmentParts={equipmentPartsWithSensorPosition} selectedComponent={selectedComponent} locationCode={locationCode} playMovie={playMovie} />
            </div>
            }
            {/* 점검/검사(승강기) */}
            {/* {(componentId && componentId === -4) && info && 
            <EquipmentElevatorInfo equipment={info} />
            } */}
          </Col>
        </Row>
    </div>
        )
    }
}

export default EquipmentViewMonitoring;